import type { Tutorial } from '@/types'
import { UNICODE } from '@/constants/unicode'
import IconBook from '@/assets/images/infoSection/poradnik-darczyncy.png?format=webp&w=150'
import IconBulb from '@/assets/images/infoSection/pierwsza-paczka.png?format=webp&w=150'
import IconGroup from '@/assets/images/infoSection/paczka-w-grupie.png?format=webp&w=150'
import IconGuide from '@/assets/images/infoSection/materialy-do-pobrania.png?format=webp&w=150'

export const THANKS_TUTORIAL = [
  {
    title: `PORADNIK${UNICODE.NEWLINE}DARCZYŃCZYŃ I${UNICODE.NON_BREAKING_SPACE}DARCZYŃCÓW`,
    text: 'odpowiedzi na najczęściej zadawane pytania ',
    link: 'https://www.szlachetnapaczka.pl/poradnik-darczyncy/',
    icon: IconBook
  },
  {
    title: `MOJA PIERWSZA${UNICODE.NEWLINE}SZLACHETNA${UNICODE.NON_BREAKING_SPACE}PACZKA`,
    text: 'porady dla tych, którzy robią Paczkę po raz pierwszy',
    link: 'https://www.szlachetnapaczka.pl/moja-pierwsza-paczka/',
    icon: IconBulb
  },
  {
    title: `SZLACHETNA PACZKA${UNICODE.NEWLINE}W${UNICODE.NON_BREAKING_SPACE}GRUPIE`,
    text: '5 kroków do przygotowania pomocy w grupie znajomych',
    link: 'https://www.szlachetnapaczka.pl/paczka-w-grupie/',
    icon: IconGroup
  },
  {
    title: `MATERIAŁY${UNICODE.NEWLINE}DO POBRANIA`,
    text: 'gotowe grafiki, teksty, checklisty, arkusze kalkulacyjne,',
    link: 'https://www.szlachetnapaczka.pl/materialy-do-pobrania/',
    icon: IconGuide
  }
] as const satisfies Tutorial[]
